import React, { useEffect, useState } from 'react';
import CommonBreadcrumbs from '../Breadcrumb/Breadcrumb';
import { images } from '../../config/images';
import { useLocation, useParams } from 'react-router-dom';
import { getCustomAPIData } from '../../config/services';

const CustomPage = () => {
  const location = useLocation();

  // const { title, content } = location.state || {};
  const slug = useParams();
  const [customPageData, setCustomPageData] = useState([]);

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    { label: customPageData?.title, url: `/${slug.page}` },
  ];

  const fetchData = async () => {
    const params = {
      type: "footer",
      slug: slug.page,
    };

    try {
      const resp = await getCustomAPIData({ params });
      console.log(resp);
      setCustomPageData(resp.data.responseBody);

    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <div className="about-us-container">
        <div className="molecule left">
          <img
            src={images.leftSpirrel}
            alt="Left Molecule"
            className="left-spinner"
          />
        </div>
        <div className="about-text">
          <h1>{customPageData?.title}</h1>
          <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
        </div>
        <div className="molecule right">
          <img
            src={images.rightSpirrel}
            alt="Right Molecule"
            className="right-spinner"
          />
        </div>
      </div>

      <div className="container-1 mt-5 mb-5">
        <h2 className="custom-title pt-5" style={{ textAlign: "center" }}>
          {customPageData?.title}
        </h2>
        <br />
        <div
          className="customepage111"
          dangerouslySetInnerHTML={{ __html: customPageData.content }}
        />
      </div>
    </div>
  );
};

export default CustomPage;